import { render } from "./Dialog-menu.vue?vue&type=template&id=1a853e4c&scoped=true"
import script from "./Dialog-menu.vue?vue&type=script&lang=js"
export * from "./Dialog-menu.vue?vue&type=script&lang=js"

import "./Dialog-menu.vue?vue&type=style&index=0&id=1a853e4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a853e4c"]])

export default __exports__